import gql from 'graphql-tag';

export const IntegrationDefinitionsQuery = gql`
  query IntegrationDefinitions($cursor: String) {
    integrationDefinitions(cursor: $cursor) {
      definitions {
        id
        integrationType
        integrationClass
        name
        title
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const IntegrationInstancesQuery = gql`
  query IntegrationInstancesAndDefinitions {
    integrationInstances {
      instances {
        id
        name
        integrationDefinitionId
      }
    }
    integrationDefinitions {
      definitions {
        id
        integrationType
        integrationClass
        name
        title
      }
    }
  }
`;

export const ImportAlertRulePack = gql`
  mutation ImportAlertRulePack($rulePackName: String!, $ruleNames: [String!]!) {
    importAlertRulePack(
      rulePackName: $rulePackName
      ruleNames: $ruleNames
      autoEvaluate: false
    ) {
      newRules {
        # big dua lipa vibes
        id
      }
      updatedRules {
        id
      }
    }
  }
`;

export const ImportAlertRulesFromFormat = gql`
  mutation ImportAlertRulesFromFormat($format: [RulePackRuleInput!]!) {
    importAlertRulesFromFormat(format: $format) {
      newRules {
        id
      }
      updatedRules {
        id
      }
    }
  }
`;

/**
 * Config fields on IntegrationDefinitions are recursive. A problem with
 * this is that graphQl does not like infinite recursion. In order to
 * remain safe and to account for this limitation, we only take 3 levels
 * of recursion in configFields. Anything beyond that will return nothing.
 */
export const configFieldFragment = gql`
  fragment ConfigFieldValues on ConfigField {
    key
    displayName
    description
    type
    format
    defaultValue
    helperText
    inputAdornment
    mask
    optional
    immutable
    computed
    options {
      value
      description
      label
      webLink
      default
    }
  }
`;
// Allow for 3 recursions in ConfigFields for IntegrationDefinitions
export const configFieldRecursiveFragment = gql`
  fragment configFieldsRecursive on IntegrationDefinition {
    configFields {
      ...ConfigFieldValues
      configFields {
        ...ConfigFieldValues
        configFields {
          ...ConfigFieldValues
        }
      }
    }
  }
  ${configFieldFragment}
`;
